<template>
  <v-dialog v-model="model" max-width="400px" @keydown.stop.esc="cancel">
    <v-card class="pa-4">
      <v-card-title class="pa-0 ma-0">
        <span class="text-h5">{{ title }}</span>
      </v-card-title>
      <v-card-text class="pa-0 mt-6">{{ text }}</v-card-text>
      <v-card-actions class="pa-0 justify-end mt-3">
        <v-btn
          size="large"
          variant="outlined"
          @click="cancel"
        >
          {{ cancelLabel }}
        </v-btn>
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          @click="confirm"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: 'Confirm' },
    text: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Confirm' },
    cancelLabel: { type: String, default: 'Cancel' }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  computed: {
    model: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
      this.model = false
    },
    cancel () {
      this.$emit('cancel')
      this.model = false
    }
  }
}
</script>
